/*
 * @Author: yuqiuyu 18180464352@163.com
 * @Date: 2022-06-15 16:48:28
 * @LastEditors: yuqiuyu 18180464352@163.com
 * @LastEditTime: 2022-07-25 14:13:28
 * @FilePath: \vueproject-master\src\global\global.js
 * @Description:
 *
 * Copyright (c) 2022 by 斯马特有限公司, All Rights Reserved.
 */
// 接口地址
// const photoUrl = "http://192.168.1.117:8022";
// const photoUrl = "http://10.2.10.1:8022";
// const photoUrl = "http://47.108.228.90:8082";
const photoUrl = "";

// 本地图片接口
const localUrl = "/static/img/假.png";
export default {
  photoUrl,
  localUrl
};



// WEBPACK FOOTER //
// ./src/global/global.js